const namespace = 'bravissimo/scroll';

export const SET_SCROLL_POINT = `${namespace}/SET_SCROLL_POINT`;
export const CLEAR_SCROLL_POINT = `${namespace}/CLEAR_SCROLL_POINT`;
